import {environment} from "../environments/environment";

export class URLS {
  static HOST = environment.serverUrl
  static BASE = this.HOST + "/api/v1/"
  static PHOTO_URL = this.HOST + "/file/"
  static FILE_UPLOAD = this.HOST + "/file/upload"

  static USERS: string = this.BASE + "user"
  static PROFILE: string = this.BASE + "profile"
  static CATEGORY: string = this.BASE + "category"
  static REPAIR: string = this.BASE + "repair"
  static PRODUCT: string = this.BASE + "product"
  static PRODUCT_ALTERNATIVE: string = this.PRODUCT + "/alternative/"
  static REGISTER: string = this.BASE + "register"
  static AUTH: string = this.BASE + "auth"
  static REFRESH: string = this.BASE + "user/refresh-token"
  static AUTH_EMAIL: string = this.AUTH + "/email"
  static REGISTER_EMAIL: string = this.REGISTER + "/email"
  static REGISTER_EMAIL_CONFIRM: string = this.REGISTER_EMAIL + "/confirm"
  static RESET: string = "reset"
  static RESET_EMAIL: string = this.RESET + "/email"
  static RESET_EMAIL_CONFIRM: string = this.RESET_EMAIL + "/confirm"

}
